"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactIntl = require("react-intl");

var _components = require("../../components");

var _Product = require("../../helpers/Product");

var _NeutralBrandingRoutes = require("../../helpers/NeutralBrandingRoutes");

var _SegmentLogs = require("../../helpers/SegmentLogs");

var _PopupType = require("../../helpers/PopupType");

var _Cookie = require("../../helpers/Cookie");

var _popup = require("../../redux/modules/popup");

var _Welcome = require("./Welcome.scss");

var _Welcome2 = _interopRequireDefault(_Welcome);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Welcome = (_dec = (0, _reactRedux.connect)(function (state) {
  return { auth: state.auth };
}, { changePopupType: _popup.changePopupType }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Welcome, _Component);

  function Welcome() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Welcome);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Welcome.__proto__ || (0, _getPrototypeOf2.default)(Welcome)).call.apply(_ref, [this].concat(args))), _this), _this.showExpiryPopup = function () {
      _this.props.changePopupType(_PopupType.PopupId.TvCodeExpiryPopup);
    }, _this.componentDidMount = function () {
      (0, _SegmentLogs.resetUser)();

      var isBusiness = _this.props.auth.realm === _Product.REALM_NAMES.Business;

      if (!isBusiness) {
        var expiryCheckIntervalInMs = 5000;
        _this.tvCodeExpiryInterval = setInterval(function () {
          // we want to read the session storage every 5 seconds so that
          // we read new expiry times when they get updated
          var tvCodeExpiryTimestamp = Number(sessionStorage.getItem(_Cookie.tvCodeExpirySessionStorageName));
          if (tvCodeExpiryTimestamp && Date.now() > tvCodeExpiryTimestamp) {
            _this.showExpiryPopup();
          }
        }, expiryCheckIntervalInMs);
      }
    }, _this.componentWillUnmount = function () {
      clearInterval(_this.tvCodeExpiryInterval);
      _this.tvCodeExpiryInterval = null;
    }, _this.getProductElement = function () {
      // New resigned pages have a simpler layout, so we don't need to show the product element.
      if ((0, _NeutralBrandingRoutes.isNeutralBrandingRoute)(_this.context.router.location.pathname)) {
        return _this.props.children;
      }

      var product = _this.props.auth.productName;
      var realm = _this.props.auth.realm;
      var element = void 0;
      switch (true) {
        case realm === _Product.REALM_NAMES.Business && product === _Product.PRODUCT_NAMES.Music:
          element = _react2.default.createElement(_components.MusicBusiness, null);
          break;
        case realm === _Product.REALM_NAMES.Stingray && (product === _Product.PRODUCT_NAMES.Music || product === _Product.PRODUCT_NAMES.Classica || product === _Product.PRODUCT_NAMES.Qello || product === _Product.PRODUCT_NAMES.Karaoke):
          element = _react2.default.createElement(
            _components.Music,
            null,
            _this.props.children
          );
          break;
        default:
          console.error("product not implemented yet");
          // TODO What do we want to show we the clientId doesn't match.
          // Error Page?
          break;
      }
      return element;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Welcome, [{
    key: "render",
    value: function render() {
      var element = this.getProductElement();

      return _react2.default.createElement(
        "div",
        { className: _Welcome2.default.welcomePage },
        _react2.default.createElement(_reactHelmet2.default, { title: "Universal Login" }),
        element
      );
    }
  }]);
  return Welcome;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object,
  changePopupType: _react.PropTypes.func,
  children: _react.PropTypes.object.isRequired
}, _class2.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
}, _temp2)) || _class);
exports.default = (0, _reactIntl.injectIntl)(Welcome);
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Welcome/Welcome.js
// module id = 2029
// module chunks = 0